import type { LogParams } from '@application/api';
import type { ParentTypeEnum } from '@gql/graphql';
import type { SelectOption } from '@presentation/components';
import type { FormMode } from '@presentation/types';
import type { Dayjs } from 'dayjs';
import type { LocationDescriptor } from 'history';
import type { MouseEventHandler } from 'react';

export interface MtLitterPageFormValues {
  // General
  images?: File[] | string[] | undefined[];
  born?: boolean;
  price?: number;
  priceFrom?: number;
  priceTo?: number;
  fixedPrice?: boolean;
  birthday?: Dayjs;
  availabilityDate?: Dayjs;
  description?: string;
  breedId?: number;
  // Parents
  [ParentTypeEnum.MOTHER]?: number;
  motherPedigree?: string | null;
  [ParentTypeEnum.FATHER]?: number;
  fatherPedigree?: string | null;
  // Litters
  malesCount?: number;
  femalesCount?: number;
  malesLeftCount?: number;
  femalesLeftCount?: number;
  microchipped?: boolean;
  vaccinated?: boolean;
  vaccinationDate?: Dayjs;
  dewormed?: boolean;
  pedigree?: string | null;
  hasLitterCode?: boolean;
  litterCode?: string | null;
}

export interface MtLitterPageFormOptions {
  breeds: SelectOption<number>[];
  animals: Record<ParentTypeEnum, SelectOption<number>[]>;
}

export interface MtLitterPageData {
  mode: FormMode;
  onEditClick?: MouseEventHandler;
  onCancelClick?: MouseEventHandler;
  onDeleteClick?: MouseEventHandler;
  onSubmitClick: MouseEventHandler;
  onBackClick?: MouseEventHandler;
  confirmBorn?: () => Promise<boolean>;
  options: MtLitterPageFormOptions;
  adminValidated?: boolean;
  archived?: boolean;
  onAddParentClick?: (parentType: ParentTypeEnum, formValues?: MtLitterPageFormValues) => void;
  link?: LocationDescriptor;
  loading?: boolean;
  canEditSpecificFields: boolean;
  showLitterCode?: boolean;
  born?: boolean;
  showImageError?: boolean;
  log?: (params: LogParams) => void;
}

export interface MtLitterPageProps extends MtLitterPageData {}
